import { css } from 'styled-components';
import { ToggleSwitchStylesProps } from './models';

export const ToggleSwitch = ({ theme, width = '50px', height = '30px', padding = '15%' }: ToggleSwitchStylesProps) => {
  return css`
    --width: ${width};
    --slider-padding: ${padding};
    height: ${height};
    position: relative;
    display: inline-block;
    width: var(--width);

    & input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    /* The slider */
    & .slider {
      border-radius: 99999px;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${theme.colors.tintDeepBlue};
      -webkit-transition: 0.4s;
      transition: translate 0.4s;
    }

    & .slider:before {
      position: absolute;
      border-radius: 50%;
      content: '';
      height: 80%;
      aspect-ratio: 1/1;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      box-shadow: 0px 2.22581px 5.93548px rgba(0, 0, 0, 0.2), 0px 2.22581px 0.741935px rgba(0, 0, 0, 0.1);
      transform: translate(var(--slider-padding), 11%);
    }

    & input:checked + .slider {
      background-color: ${theme.colors.primaryBright};
    }

    & input:focus + .slider {
      box-shadow: 0 0 1px ${theme.colors.primaryBright};
    }

    & input:checked + .slider:before {
      transform: translate(calc(var(--width) - calc(100% + var(--slider-padding))), 11%);
    }
  `;
};
